import React from 'react';

import './style.css';

const Checkbox = props => (
	<div className="dpd-checkbox">
		<input 
			id={props.id || props.label}
			onChange={() => { props.onChange(!props.value) }}
			checked={props.value}
			type="checkbox">
		</input>
		<label htmlFor={props.id || props.label}></label>
		<span className="check-label">{props.label}</span>
	</div>
)

export default Checkbox;


// WEBPACK FOOTER //
// ./src/components/Checkbox/index.js